import { activity } from "./activity";
import { apps } from "./apps";
import { athletes } from "./athletes";
import { chat } from "./chat";
import { clubs } from "./clubs";
import { coach } from "./coach";
import { contentModeration } from "./content-moderation";
import { courtAvailability } from "./court-availability";
import { courts } from "./courts";
import { demoClubs } from "./demo-clubs";
import { directory } from "./directory";
import { feedback } from "./feedback";
import { finance } from "./finance";
import { games } from "./games";
import { locations } from "./locations";
import { mailing } from "./mailing";
import { matches } from "./matches";
import { moderation } from "./moderation";
import { news } from "./news";
import { notifications } from "./notifications";
import { outbox } from "./outbox";
import { platformStats } from "./platform-stats";
import { playerReports } from "./player-reports";
import { profiles } from "./profiles";
import { reports } from "./reports";
import { scraper } from "./scraper";
import { session } from "./session";
import { shareLinks } from "./share-links";
import { sites } from "./sites";
import { tournaments } from "./tournaments";
import { users } from "./users";

export const adminApi = {
	activity,
	apps,
	athletes,
	chat,
	clubs,
	coach,
	contentModeration,
	courtAvailability,
	courts,
	demoClubs,
	directory,
	feedback,
	finance,
	games,
	locations,
	mailing,
	matches,
	moderation,
	news,
	notifications,
	outbox,
	platformStats,
	playerReports,
	profiles,
	reports,
	scraper,
	session,
	shareLinks,
	sites,
	tournaments,
	users,
};
